import { CONTENT_ANALYTICS } from "constants/types";
import { convertSnakeCaseKeysToCamelCase } from "utils";

export interface Contact {
  contactEmail: string;
  contactId: number;
  clickCount: number;
}
export interface ClickedBy {
  totalCount: number;
  contacts: Contact[];
}

export interface Email {
  emailId: string;
  emailName: string;
}

export interface IArticle {
  articleId: number;
  articleTitle: string;
  articleImage: string;
  articleLink: string;
  clickedBy: ClickedBy;
  articleScore: number;
  emailName: string;
  emailDate: string;
}

export interface IAnalyticsContent {
  data: IArticle[];
  searchedData: IArticle[];
  totalCount: number;
  loading: boolean;
  loaded: boolean;
  filterReset: boolean;
  searchReset: boolean;
  emailSearchValue: string;
}

const initialAnalyticsContent = {
  data: [],
  searchedData: [],
  totalCount: 0,
  loading: false,
  loaded: false,
  filterReset: false,
  searchReset: false,
  emailSearchValue: "",
};

export const analyticsContentReducer = (state: IAnalyticsContent = initialAnalyticsContent, action: any) => {
  const newState = { ...state };
  switch (action.type) {
    case CONTENT_ANALYTICS.FILTER_RESET:
      newState.filterReset = action.payload;
      return newState;
    case CONTENT_ANALYTICS.SEARCH_RESET:
      newState.searchReset = action.payload;
      return newState;
    case CONTENT_ANALYTICS.SET_SEARCH:
      let searchValue = action.payload.searchValue;
      let articleId = action.payload.articleId;
      if (searchValue.length > 0) {
        newState.emailSearchValue = searchValue;
        let articleItem: IArticle = state.data.filter((item: any) => item.articleId === articleId)[0];
        let srchEmails = articleItem.clickedBy.contacts.filter((item: any) =>
          item.contactEmail.toLowerCase().includes(searchValue.toLowerCase())
        );
        newState.searchedData = [...srchEmails];
      } else {
        newState.searchedData = [];
        newState.emailSearchValue = "";
      }
      return newState;
    case CONTENT_ANALYTICS.LOAD:
      newState.loading = true;
      newState.loaded = false;
      newState.data = [];
      newState.totalCount = 0;
      break;
    case CONTENT_ANALYTICS.LOAD_SUCCESS:
      newState.loading = false;
      newState.loaded = true;
      newState.data = [
        ...action.payload?.data?.articles?.map((content: any) => convertSnakeCaseKeysToCamelCase(content)),
      ];
      newState.totalCount = action.payload.data.total_articles_count;
      break;
    case CONTENT_ANALYTICS.LOAD_MORE:
      newState.loading = true;
      newState.loaded = false;
      break;
    case CONTENT_ANALYTICS.LOAD_MORE_SUCCESS:
      newState.loading = false;
      newState.loaded = true;
      newState.data = [
        ...newState.data,
        ...action.payload?.data?.articles?.map((content: any) => convertSnakeCaseKeysToCamelCase(content)),
      ];
      newState.totalCount = action.payload.data.total_articles_count;
      break;
    case CONTENT_ANALYTICS.LOAD_FAIL:
      newState.loading = false;
      newState.loaded = false;
      newState.data = [];
      newState.totalCount = 0;
      break;
    case CONTENT_ANALYTICS.RESET:
      newState.loaded = false;
      newState.loading = false;
      newState.data = [];
      newState.totalCount = 0;
      break;
    default:
      break;
  }
  return newState;
};
